import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import Config from '../../../../../Config';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import attentionIcon from '../../images/attention-icon.svg';
import {goToPageAsync} from '../../LocalCellularTroubleshootingWizardBlockThunk';
import {setIsShowPopup, reportDWH} from '../../LocalCellularTroubleshootingWizardBlockSlice';
import {connect} from 'react-redux';
import {buildUrlAndOpenSameWindow, prepareUrl} from '../../../../../utilities/StringHelpers/StringHelpers';

const StepPage = (props) => {
  const [selectedRadio, setSelectedRadio] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    setSelectedRadio(null);
  }, [props.pageContent]);

  function handleRadioChange(index) {
    setError('');
    setSelectedRadio(index);
  }

  function onclickBtn(nextPage) {
    let page = nextPage;
    if (props.pageContent.selections?.length > 0) {
      if (selectedRadio == null) {
        setError('יש לבחור אחת מהאפשרויות כדי להמשיך');
        return;
      }
      const selected = props.pageContent.selections[selectedRadio];
      page = selected.nextPage;
    }
    props.goToPageAsync({pageType: page});
  }

  function handleOnClickLink(item) {
    props.reportDWH({
      actionType: props.dwhWizardName + ' Page',
      status: 'Ongoing',
      messageText: props.dwhWizardName + ' Action Link Clicked',
      param1: item.text,
    });
    prepareUrl(item.link, props.context);
  }

  function handleOnClickOpenPopupBtn(item) {
    if (item.isOpenPopUp) {
      props.setIsShowPopup(true);
    }
  }

  return (
    <div className='step-page'>
      {props.pageContent.icon && <Image className='icon' src={props.pageContent.icon} alt={''} />}
      {props.pageContent.title && <h1 className='title'>{props.pageContent.title}</h1>}
      {props.pageContent.subTitle && <h2 className='sub-title'>{props.pageContent.subTitle}</h2>}
      <div className='content-wrapper'>
        {props.pageContent.selections?.length > 0 && (
          <div className='selection-wrapper'>
            {props.pageContent.selections?.map((item, i) => (
              <div className={`radio-wrapper ${selectedRadio === i ? 'checked' : ''}`} key={i}>
                <RadioInput
                  name={`selection-type`}
                  id={`selection-type-${i}`}
                  value={item.nextPage}
                  label={item.text}
                  checked={selectedRadio === i}
                  onChange={(e) => handleRadioChange(i)}
                />
              </div>
            ))}
          </div>
        )}
        {props.pageContent.links?.length > 0 &&
          props.pageContent.links.map((item, i) =>
            item.isOpenPopUp ? (
              <button key={i} className='open-popup-btn' onClick={() => handleOnClickOpenPopupBtn(item)}>
                {item.text}
              </button>
            ) : (
              <a key={i} className='link' onClick={() => handleOnClickLink(item)}>
                {item.text}
              </a>
            ),
          )}
        {props.pageContent.alert?.text && (
          <div className='attention-text-wrapper'>
            <div className='text-wrapper'>
              <Image src={attentionIcon} alt='attention icon' />
              <p className='text'>
                {props.pageContent.alert?.text}
                {props.pageContent.alert?.linkObj?.text &&
                (<a className='attention-link' onClick={() => handleOnClickLink(props.pageContent.alert.linkObj)}>
                    {props.pageContent.alert.linkObj?.text}
                </a>)}
              </p>
            </div>
          </div>
        )}
      </div>
      <div className={`footer ${props.pageContent.textAboveButtons ? 'box-shadow' : ''}`}>
        {error && <div className='error-text'>{error}</div>}
        {props.pageContent.textAboveButtons && <div className='buttons-title'>{props.pageContent.textAboveButtons}</div>}
        <div className='buttons-wrapper'>
          {props.pageContent.buttons?.map((item, i) => (
            <BtnSubmit key={i} text={item.text} onclick={() => onclickBtn(item.nextPage)} formid={'step-page'} />
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    pageContent: state.localCellularTroubleshootingWizardBlock.pageContent,
    dwhWizardName: state.localCellularTroubleshootingWizardBlock.dwhWizardName,
  };
};

const mapDispatchToProps = {
  goToPageAsync,
  setIsShowPopup,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(StepPage);
